<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Footer from '../common/Footer.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import Title from '../common/Title.svelte';
  import LeftPanel from '../ui-components/LeftPanel.svelte';
  import SmallHeader from '../common/SmallHeader.svelte';
  import Overview from '../ui-components/fields/Overview.svelte';
  import Tour from '../ui-components/fields/Tour.svelte';
  import Schedule from '../ui-components/Schedule.svelte';
  import Common from '../js/common.js';

  export let params;

  if (!Global.pages.includes('fields')) {
    window.location.href = window.localStorage.getItem('currentPage') || './';
  }

  let lang;

  let user = JSON.parse(window.localStorage.getItem('user'));

  let field;
  let games = [];

  let loading = true;
  let error;

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/fields/get/${params.field}`);

    if (response.ok) {
      const data = await response.json();

      field = data.field;
      games = data.games;
      user = data.user;

      if (user) window.localStorage.setItem('user', JSON.stringify(data.user));
      else window.localStorage.removeItem('user');

      i18n.pageTitle = {
        cs: `${field.name.cs} | ${Global.project.name.cs}`,
        en: `${field.name.en} | ${Global.project.name.en}`,
      };

      i18n.title = {
        cs: field.name.cs,
        en: field.name.en,
      };
    } else {
      if (response.status === Common.NOT_FOUND) window.location.href = './#/fields';
      else error = true;
    }

    loading = false;
  })();

  const headerElements = [
    {
      value: 'overview',
      label: {
        cs: 'Přehled',
        en: 'Overview',
      },
    },
    {
      value: 'tour',
      label: {
        cs: 'Prohlídka',
        en: 'Tour',
      },
    },
    {
      value: 'schedule',
      label: {
        cs: 'Rozpis',
        en: 'Schedule',
      },
    },
  ];

  let section = headerElements.map(element => element.value).includes(params?.section) ? params.section : 'overview';

  const i18n = {
    pageTitleLoading: {
      cs: `Načítání... | ${Global.project.name.cs}`,
      en: `Loading... | ${Global.project.name.en}`,
    },
    pageTitleError: {
      cs: `Něco se pokazilo | ${Global.project.name.cs}`,
      en: `Something went wrong | ${Global.project.name.en}`,
    },
  };

  let pageTitle;

  $: if (loading) {
    pageTitle = i18n.pageTitleLoading[lang];
  } else if (error) {
    pageTitle = i18n.pageTitleError[lang];
  } else {
    pageTitle = i18n.pageTitle[lang];
  }
</script>

<svelte:head>
  <title> {pageTitle} </title>
</svelte:head>

<Header page='fields/{params.field}' bind:lang bind:user/>

<Loading bind:display={loading} fullHeight={true}/>
<Error bind:display={error} fullHeight={true} bind:lang/>

{#if !loading && !error}
  <Title img='field/{field.photo ? `${field.code}-${field.photo}` : 'default'}.jpg'
    alt='{field.name.en} field photo' title={i18n.title[lang]} color='green'/>

  <div class='fields-field'>
    <div class='fields-field-box'>
      <div class='fields-field-box-left-panel'>
        <LeftPanel img={`static/field/${field.shortcut}.jpg`} alt={`${field.name.en} photo`} shortcut={field.shortcut}
          page='fields' code={field.code} bind:lang bind:user/>
      </div>

      <div class='fields-field-box-main'>
        <div class='fields-field-box-main-small-header'>
          <SmallHeader elements={headerElements} bind:value={section} bind:lang/>
        </div>

        {#if section === 'overview'}
          <Overview value={field} bind:lang/>
        {:else if section === 'tour'}
          <Tour value={field} bind:lang/>
        {:else}
          <Schedule games={games} narrow={true} bind:lang bind:user/>
        {/if}
      </div>
    </div>
  </div>
{/if}

<Footer bind:lang/>

<style>
  .fields-field {
    max-width: 1450px;

    padding: 40px 60px;

    margin: auto;
  }

  .fields-field-box {
    display: flex;
    gap: 40px;
  }

  .fields-field-box-main {
    display: flex;
    flex-direction: column;
    gap: 40px;

    width: 100%;
  }

  @media only screen and (max-width: 1050px) {
    .fields-field-box {
      flex-direction: column;
    }
  }

  @media only screen and (max-width: 900px) {
    .fields-field {
      padding: 40px;
    }
  }

  @media only screen and (max-width: 850px) {
    .fields-field-box {
      flex-direction: column;
    }
  }

  @media only screen and (max-width: 350px) {
    .fields-field {
      padding: 40px 20px;
    }
  }
</style>
